import React from 'react';
import { Page } from '../Page';
export function PageGLP1Overview2() {
  return <Page pageNumber={3} variant="light" data-id="element-1395" data-mp="95qwh45m9442">
      <div className="flex flex-col h-full" data-id="element-1396" data-mp="96s9vfa3u2oy">
        {/* Image at Top */}
        <div className="h-[340px] overflow-hidden mb-10" data-id="element-1397" data-mp="e4u32t18vie5">
          <img src="https://cdn.magicpatterns.com/uploads/sSsZcR853PsxEnjk3uuBHM/glp1_transparent.png" alt="GLP-1 vial and syringe system" className="w-full h-full object-contain" data-id="element-1398" data-mp="e7g9uqgb9tvb" />
        </div>

        {/* Two Column Layout */}
        <div className="grid grid-cols-2 gap-10 flex-1" data-id="element-1399" data-mp="s3a90hra94v8">
          {/* Left Column */}
          <div className="space-y-5" data-id="element-1400" data-mp="wwwarevwroc9">
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1401" data-mp="wxxppug1ouz9">
              The signals that tell you you're full actually stick around,
              instead of disappearing quickly and leaving you thinking about
              your next meal. You feel full sooner. You stay full longer. And
              over time, food starts to take up less space in your day.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1402" data-mp="349n8narhv9nt">
              You're not constantly planning your next meal or fighting off
              cravings. Eating becomes more straightforward, more controlled,
              and a lot less mental.
            </p>
            <p className="text-sm text-[#1F1F1F] leading-[1.8] font-medium italic" data-id="element-1403" data-mp="2pfr29hewgr38">
              That's the shift.
            </p>
          </div>

          {/* Right Column - The Gut Effect */}
          <div data-id="element-1404" data-mp="3i4fvku9prs4f">
            <h2 className="text-2xl font-serif text-[#1F1F1F] leading-tight mb-2" data-id="element-1405" data-mp="3i3mua8tixuto">
              The Gut Effect
            </h2>
            <div className="w-10 h-0.5 bg-tealslate mb-4" data-id="element-1406" data-mp="3da1z0ojbfey6" />
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1407" data-mp="38cjt770lhfue">
              One of the first things this medication does is slow down how
              quickly food moves through your stomach. Digestion takes longer,
              which means nutrients are released more gradually and your blood
              sugar stays more stable after meals. That stability plays a big
              role in how you feel. Instead of getting hungry again shortly
              after eating, you stay physically full for longer.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mt-4" data-id="element-1408" data-mp="1pcszud5oh6zl">
              This is where medications like semaglutide and tirzepatide are
              especially effective. It's also why many people notice they
              naturally start eating smaller portions without trying and still
              feel satisfied for hours afterward.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}